// pages/BillingPage.tsx
import { Layout, Page } from '@nimbus-ds/patterns';
import { ProfileInfo, TrialBar } from '../../components';
import { useTranslation } from 'react-i18next';
import { BillingInfo } from '../../components/BillingInfo';
import { Box } from '@nimbus-ds/components';

const ProfilePage = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Header title={t('ProfilePage.Title')} />
      <Page.Body>
        <Box display="grid" gap="4">
          <TrialBar showCanceled={false} />
          <Layout columns="2 - symmetric">
            <Layout.Section>
              <ProfileInfo />
            </Layout.Section>
            <Layout.Section>
              <BillingInfo />
            </Layout.Section>
          </Layout>
        </Box>
      </Page.Body>
    </Page>
  );
};

export default ProfilePage;
